
//page 714

import style from "../RoundVideoResultFive/CSS/RoundVideoResult.module.css";
import Round from "../RoundVideoResultFive/Component/Round";
import Title from "../RoundVideoResultFive/Component/Title";
import SubTitle from "../RoundVideoResultFive/Component/SubTitle";
import Banner from "../RoundVideoResultFive/Component/Banner";
import coverPhoto from "../RoundVideoResultFive/img/banner.png";
import Slider from "../RoundVideoResultFive/Component/Slider";
import Button from "../RoundVideoResultFive/Component/Button";
import FinalResult from "./Component/FinalResult";

import sliderOne from "../RoundVideoResultFive/img/sliderOne.png";
import sliderTwo from "../RoundVideoResultFive/img/sliderThree.png";
import sliderThree from "../RoundVideoResultFive/img/sliderTwo.png";
import sliderFour from "../RoundVideoResultFive/img/sliderOne.png";
import sliderFive from "../RoundVideoResultFive/img/sliderTwo.png";
import sliderSix from "../RoundVideoResultFive/img/sliderThree.png";

import run_1 from './img/run_1.png';
import run_2 from './img/run_2.png';
import run_3 from './img/run_3.png';


const sliders = [
    {slider: sliderOne},
    {slider: sliderTwo},
    {slider: sliderThree},
    {slider: sliderFour},
    {slider: sliderFive},
    {slider: sliderSix},
];

const finalResultTwo =[
    {
        position: 'winner',
        name:'user name',
        mark: '54',
        comment:'superstar comment',
        userImage: run_1
    }
]

const finalResult =[
    {
        position: 'winner',
        name:'user name',
        mark: '54',
        comment:'superstar comment',
        userImage: run_1
    },
    {
        position: '1st runner up',
        name:'user name',
        mark: '54',
        comment:'superstar comment',
        userImage: run_2
    },
    {
        position: '2nd runner up',
        name:'user name',
        mark: '54',
        comment:'superstar comment',
        userImage: run_3
    },
    {
        position: '3rd runner up',
        name:'user name',
        mark: '54',
        comment:'superstar comment',
        userImage: run_1
    },
    {
        position: '5th position',
        name:'user name',
        mark: '54',
        comment:'superstar comment',
        userImage: run_2
    },
    {
        position: '6th position',
        name:'user name',
        mark: '54',
        comment:'superstar comment',
        userImage: run_3
    },
    {
        position: '7th position',
        name:'user name',
        mark: '54',
        comment:'superstar comment',
        userImage: run_1
    }
]

const RoundVideoResultSix = () => {
    return (
        <>
            <div className={style.section}>
                <Round round={'01'} status={'done'}/>
                <Round round={'02'} status={'done'}/>
                <Round round={'03'} status={'done'}/>
                <Round round={'04'} status={'done'}/>
                <Round round={'05'} status={'done'}/>
                <Round round={'06'} status={'done'}/>
                <Round round={'07'} status={'running'}/>
                <Round round={'08'} status={'pending'}/>
            </div>
            <div>
                <Title title={'round status'}/>
            </div>

            <div>
                <SubTitle subTitle={'submitted content'}/>
            </div>

            <div>
                <Banner title={'1st round time duration june 25 - july 30'} coverPhoto={coverPhoto}/>
            </div>

            <div>
                <Title title={'audition round-7'}/>
            </div>

            <div>
                <SubTitle subTitle={'total video - 75'}/>
            </div>

            <div>
                <Slider sliders={sliders}/>
            </div>

            <div>
                <FinalResult data={finalResult}/>
            </div>

            <div style={{margin: '40px 0px 30px', textAlign: 'center'}}>
                <Button text={'request for manager approval'}/>
            </div>
        </>
    );
};

export default RoundVideoResultSix;